// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__OnGPq","profileList":"Profile_profileList__1Qun7","profileLink":"Profile_profileLink__dAeQL","fileLink":"Profile_fileLink__0ARaS"};